import { Component, ViewChild } from '@angular/core';
import { ScApiService } from '@sc-ui';
import { UserService } from 'src/services/user.service';
import { LocalizationService } from 'src/services/localization.service';
import Chart from 'chart.js/auto';
import { fadeIn } from 'src/transitions';
import { texts } from './reporting.texts';

@Component({
  standalone: false,
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss'],
  animations: [fadeIn]
})
export class ReportingComponent {

  texts = texts;

  state = 'out';

  reporting: any;

  months = 6;

  charts: any = {};

  countByWeekChart?: Chart;

  constructor(
    public userService: UserService,
    private api: ScApiService,
    public loc: LocalizationService,
    public user: UserService) { }

  ngOnInit() {

    this.reload();
  }

  createOrUpdateChart(chartId, data, label) {

    if (!data) return;

    const listingLabels = data.map((i: any) => i.Label);
    const listingData = data.map((i: any) => i.Value);

    var chartConfig: any = {
      type: 'bar',
      data: {
        labels: listingLabels,
        datasets: [
          {
            type: 'bar',
            label: label,
            data: listingData,
            backgroundColor: 'rgba(0,98,215,0.8)',
            borderColor: 'rgba(0,98,215,0.8)',
            borderRadius: 8
          }
        ]
      },
      options: {
        plugins: {
          legend: {
            display: false
          }
        }
      }
    };

    if (this.charts[chartId]) {
      this.charts[chartId].data.datasets[0].data = chartConfig.data.datasets[0].data;
      this.charts[chartId].data.labels = chartConfig.data.labels;
      this.charts[chartId].update();
    } else {
      this.charts[chartId] = new Chart(chartId, chartConfig);
    }
  }

  reload() {
    this.api.get('projects/reporting?ownership=All&months=' + this.months).subscribe((d: any) => {
      this.reporting = d;

      if (!d.IsEnabled) {
        this.state = 'in'; 
        return;
      }

      this.createOrUpdateChart('contactsPerWeekChart', d.ContactsPerWeek, texts.charts.contacts[this.loc.language])
      this.createOrUpdateChart('visitsPerWeekChart', d.VisitsPerWeek, texts.charts.visitors[this.loc.language])
      this.createOrUpdateChart('listingsPerWeekChart', d.ListingsPerWeek, texts.charts.applications[this.loc.language])

      const countLabels = d.NotOrderedByWeek.map((i: any) => i.Label);
      const countData = d.NotOrderedByWeek.map((i: any) => i.Value);
      const orderCountLabels = d.OrderedByWeek.map((i: any) => i.Label);
      const orderCountData = d.OrderedByWeek.map((i: any) => i.Value);

      if (this.countByWeekChart) {
        this.countByWeekChart.data.labels = countLabels;
        this.countByWeekChart.data.datasets[1].data = countData;
        this.countByWeekChart.data.datasets[0].data = orderCountData;
        this.countByWeekChart.update();
      } else {
        this.countByWeekChart = new Chart('countByWeekChart', {
          type: 'bar',
          data: {
            labels: countLabels,
            datasets: [
              {
                label: texts.charts.approved[this.loc.language],
                data: orderCountData,
                backgroundColor: 'rgba(0,98,215,0.8)',
                borderColor: 'rgba(0,98,215,0.8)',
                borderRadius: 8,
                stack: 'stack1'
              },
              {
                label: texts.charts.notApproved[this.loc.language],
                data: countData,
                backgroundColor: 'rgba(0,98,215,0.5)',
                borderColor: 'rgba(0,98,215,0.8)',
                borderRadius: 8,
                stack: 'stack1'
              }
            ]
          },
          options: {
            responsive: true,
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true
              }
            }
          }
        });
      }

      this.state = 'in'; 


    });
  }


}
